<template>
  <div>
    <div class="contact-grid">
      <div class="tender-block grey_public">
        <div v-if="contactPerson">
          <h5 class="title_public">{{ $t('Contact person') }}</h5>
          <div class="person-card">
            <img v-if="contactAvatar" loading="lazy" :src="contactAvatar" alt="" class="avatar" />
            <div>
              <div v-if="contactName">{{ contactName }}</div>
              <div v-if="contactPosition" class="text-secondary">
                {{ contactPosition }}
              </div>
            </div>
          </div>
        </div>
        <div class="info-block">
          <div class="contact-block">
            <a
              v-if="contactEmail"
              :href="`mailto:${contactEmail}`"
              class="contact-item w-inline-block"
            >
              <div class="icon-20 w-embed">
                <MailIcon class="grey-500-icon" />
              </div>
              <div>{{ contactEmail }}</div>
            </a>
            <a
              v-if="contactPhoneNumber"
              :href="`tel:${contactPhoneNumber}`"
              class="contact-item w-inline-block"
            >
              <div class="icon-20 w-embed">
                <PhoneIcon class="grey-500-icon" />
              </div>
              <div>{{ contactPhoneNumber }}</div>
            </a>
          </div>
        </div>
        <Button type="secondary" icon="message" class="ask-question-btn">
          {{ $t('Ask question online') }}
        </Button>
      </div>
      <div class="tender-block grey_public">
        <div>
          <h5 class="title_public">{{ $t('If you need help') }}</h5>
          <div class="person-card">
            <img loading="lazy" src="/images/fix-logo.png" alt="" class="avatar" />
            <div>
              <div>{{ $t('Fixtender support') }}</div>
              <div class="text-secondary">{{ supportPhone }}</div>
            </div>
          </div>
        </div>
        <Button type="secondary" icon="message-filled" @click.native="openSupportChat">
          {{ $t('Open chat') }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
  import PhoneIcon from '@/assets/icons/phone.svg';
  import MailIcon from '@/assets/icons/mail.svg';
  import { mapGetters, mapState } from 'vuex';
  import { openSupportChat } from '@/integrations';
  import Button from '@/components/ui-v2/Button';

  export default {
    name: 'ContactTabOfPublicTender',
    components: {
      PhoneIcon,
      MailIcon,
      Button,
    },
    computed: {
      ...mapState('global', ['supportPhone']),
      ...mapState('publicTender', ['contactPerson']),
      ...mapGetters('publicTender', [
        'contactAvatar',
        'contactName',
        'contactPosition',
        'contactEmail',
        'contactPhoneNumber',
      ]),
    },
    methods: {
      openSupportChat,
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/pages/public-tender';
</style>
